import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MaestroModel } from "../maestro.model";
import { IResponse } from "src/app/pages/base/interfaces";
import { CajaService } from "src/app/services/administracion/caja.service";

export class Caja extends MaestroModel {

    public static RECORD_NAME = 'cajas';
    public static CODIGO_REGISTRO = 'caja';
    public static CODIGO_MODULO = 'administracion';
    public static NOMBRE_SINGULAR = 'Caja';
    public static NOMBRE_PLURAL = 'Cajas';

    public static TIPO_IMPRESORA_USB = 1;
    public static TIPO_IMPRESORA_BLUETOOTH = 2;

    public static TIPOS_IMPRESORA = [
        { valor: 1, nombre: 'USB' },
        { valor: 2, nombre: 'BlUETOOTH' },
    ];

    private _idEmpresa:                     number;
    private _nombreEmpresa:                 string;
    private _idSucursal:                    number;
    private _nombreSucursal:                string;
    private _tipoImpresora:                 number;

    constructor() {
        super();
        const currentUser = this.seguridad.getCurrentUser();
        if ( !currentUser?.empresa?.autogestion ) {
            this._idEmpresa = currentUser.id_empresa;
            this._nombreEmpresa = currentUser.empresa.nombre;
            this._idSucursal = currentUser.id_sucursal;
            this._nombreSucursal = currentUser.sucursal.nombre;
        }
        this._tipoImpresora = Caja.TIPO_IMPRESORA_USB;
    }

    public set idEmpresa( idEmpresa: number ) { this._idEmpresa = idEmpresa; }
    public get idEmpresa(): number { return this._idEmpresa; }

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreEmpresa = nombreEmpresa; }
    public get nombreEntidad(): string { return this._nombreEmpresa; }

    public set idSucursal( idSucursal: number ) { this._idSucursal = idSucursal; }
    public get idSucursal(): number { return this._idSucursal; }

    public set nombreSucursal( nombreSucursal: string ) { this._nombreSucursal = nombreSucursal; }
    public get nombreSucursal(): string { return this._nombreSucursal; }

    public set tipoImpresora( tipoImpresora: number ) { this._tipoImpresora = tipoImpresora; }
    public get tipoImpresora(): number { return this._tipoImpresora; }



    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'id', label: 'ID', type: 'id' },
            { field: 'nombre', label: 'Nombre',  type: 'text'},
            { field: 'sucursal.nombre', label: 'Sucursal',  type: 'ref', refName: 'Sucursal'},
        ]
    }

    private async cargarDatos( objeto: Record<string, any> ) {
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.empresa?.nombre;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.sucursal?.nombre;
        this._tipoImpresora = objeto.tipo_impresora;
    }

    override  async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        await this.cargarDatos( objeto );
    }

    override  async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        await this.cargarDatos( objeto );
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    override  async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa, Validators.required));
        fg.addControl("id_sucursal", new FormControl(this._idSucursal, Validators.required));
        fg.addControl("nombre_sucursal", new FormControl(this._nombreSucursal, Validators.required));
        fg.addControl("tipo_impresora", new FormControl(this._tipoImpresora));
        return fg;
    }

    override  async guardar( service: CajaService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    override  async actualizar( service: CajaService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    override  async eliminar( service: CajaService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}